import Dropdown from "../../../shared/v2/Dropdown/Dropdown";

const ActivitiesDropdown = ({ activity, options, onActivityChosen }) => {
  const onOptionSelected = ({ value }) => {
    onActivityChosen(value);
  };

  return (
    <Dropdown
      className="tw-whitespace-nowrap"
      value={activity}
      options={options}
      onChange={onOptionSelected}
      components={{
        SingleValue: ActivitiesValue,
        ValueContainer: ActivitiesContainer,
        Control: ActivitiesControl,
        Menu: ActivitiesMenu,
      }}
    />
  );
};

export default ActivitiesDropdown;

const ActivitiesControl = ({ componentProps, children }) => (
  <Dropdown.Control
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...componentProps}
    className="tw-flex tw-justify-center tw-cursor-pointer tw-items-center tw-gap-[9px] tw-text-gray-75"
  >
    {children}
  </Dropdown.Control>
);

const ActivitiesContainer = ({ componentProps, children }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Dropdown.ValueContainer {...componentProps} className="tw-flex tw-items-center">
    {children}
  </Dropdown.ValueContainer>
);

const ActivitiesValue = ({ componentProps, children }) => (
  <Dropdown.SingleValue
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...componentProps}
    className="tw-text-14px tw-font-normal tw-text-gray-75"
  >
    {children}
  </Dropdown.SingleValue>
);

const ActivitiesMenu = ({ componentProps, children }) => (
  <Dropdown.Menu
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...componentProps}
    preserveStyle
    className="!tw-w-[220px] !tw-z-30"
  >
    {children}
  </Dropdown.Menu>
);
